import { Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CampaignTypeEnumm, ICommunityPlaque } from '@sml/utility';
import { BUY_STORY_PLAQUE_URL } from './item-donation.constants';
import { SearchDropdownComponent } from '@sml/dropdown';

@Component({
  selector: 'sml-item-donation',
  imports: [CommonModule, ReactiveFormsModule, SearchDropdownComponent],
  templateUrl: './item-donation.component.html',
})
export class ItemDonationComponent implements OnChanges {
  @Input() form!: FormGroup;
  @Input() public communityPlaquesData!: ICommunityPlaque;
  storyPlaqueBuyUrl = BUY_STORY_PLAQUE_URL;
  isQrPlaqueRequired = false;
  public plaques: { label: string; value: number }[] = [];
  @Input() campaignType!:number;
CampaignTypeEnumm= CampaignTypeEnumm;

  ngOnChanges(): void {
     const qrValue = this.control['qrPlaque'].value;
     if(qrValue){
       this.control['qrPlaque'].patchValue(null)
      }

    this.isQrPlaqueRequired = this.control['qrPlaque']?.hasValidator(Validators.required)
    this.plaques = this.plaqueKeys.map(key => ({
      label: (this.communityPlaquesData as any)[key],
      value: Number(key)
    }));

    if(qrValue){
      setTimeout(() => {
        this.control['qrPlaque'].patchValue(qrValue)
      }, 0);
    }
  }

  get control() {
    return this.form.controls;
  }

  get plaqueKeys() {
    return Object.keys(this.communityPlaquesData);
  }
  getDonatedByName(){
    if(this.campaignType === CampaignTypeEnumm['Sponsorship']){
      return 'Sponsored Name';
    }
    else if(this.campaignType === CampaignTypeEnumm['Registration']){
      return 'Participant Name';
    }
    return 'Donated by';
  }
  getDedicatedToName(){
    return 'Dedicated to';

  }
  getDedicatedToNamePlaceholder(){
    if(this.campaignType === CampaignTypeEnumm['Sponsorship'] || this.campaignType === CampaignTypeEnumm['Registration']){
      return ' Enter Full Name of Individual, Group, or Organization';
    }
    return 'Enter Name';
  }
  getDonatedByNamePlaceholder(){
    return 'Enter Name'
  }
  onControlTouched() {
    this.control['qrPlaque'].markAsTouched();
    this.control['qrPlaque'].updateValueAndValidity();
  }
  onControlDirty() {
    this.control['qrPlaque'].markAsDirty();
    this.control['qrPlaque'].updateValueAndValidity();
  }
}
